// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div#home {
  .grid {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-evenly;
    align-content: stretch;
    gap: 10px;

    & > * {
      flex-grow: 1;
      flex-basis: 1px;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./frontend/app-home/page-home.css"],"names":[],"mappings":"AAAA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,6BAA6B;IAC7B,sBAAsB;IACtB,SAAS;;IAET;MACE,YAAY;MACZ,eAAe;IACjB;EACF;AACF","sourcesContent":["div#home {\n  .grid {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: space-evenly;\n    align-content: stretch;\n    gap: 10px;\n\n    & > * {\n      flex-grow: 1;\n      flex-basis: 1px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
